module.exports = __webpack_public_path__ + "static/media/logo.2913d0ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = 1433
// module chunks = 7